import { NgModule } from "@angular/core";
import { CommonPackageModule } from "src/app/modules/common-package.module";
import { CommonFeatureModule } from "../../common/common.module";
import { ReportingdashboardComponent } from "../component/reportingdashboard.component";

@NgModule({
  declarations: [
    ReportingdashboardComponent
  ],
  imports: [
    CommonPackageModule,
    CommonFeatureModule
  ]
})
export class ReportingDashboardModule { }
